import QueryString from 'qs'

import { putRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'
import { SimpleResult } from '../../types/PaginatedResult'
import { SClassified } from '../../types/api/Classified'
import { classifiedTransformer } from '../../transformers/classifiedTransformer'
import { Status } from '../../types/Classified'

type ArchiveResponse = SimpleResult<SClassified>

export type ArchiveParams = {
  id: number
  suggestions: string
  recommended: boolean
  filled: boolean
  service: string
}

const archive = ({ id, ...payload }: ArchiveParams) => {
  return putRestRequest({
    url:
      api.REST_API_URL +
      `/classifieds/${id}?${QueryString.stringify({
        populate: {
          classifiedCategory: {
            fields: ['name', 'form'],
          },
        },
      })}`,
    data: {
      data: {
        ...payload,
        classifiedStatus: Status.Archived,
        archivedAt: new Date(),
      },
    },
    transformer: (response: ArchiveResponse) => {
      return classifiedTransformer(response.data)
    },
  })
}

export default archive
